export const useRedirectHandler = () => {
  const whatsappApi = import.meta.env.VITE_WHATSAPP_REDIRECT_API;
  const contactSupport = import.meta.env
    .VITE_PAGOL_WHATSAPP_CONTACT_FOR_SUPPORT;

  const toWhatsAppSupport = () => {
    if (whatsappApi && contactSupport) {
      window.open(`${whatsappApi}/send?phone=${contactSupport}`, '_blank');
    } else {
      console.error('FALHA NA CONFIGURAÇÃO DO WHATSAPP');
    }
  };

  return {
    toWhatsAppSupport,
  };
};
